import React from 'react'
import Theme from '@refera/ui-core'

export function TypeChip({ isServiceMandatory }) {
  const color = isServiceMandatory ? Theme.Colors.Green.Base : Theme.Colors.Orange.Base
  const label = isServiceMandatory ? 'Obrigatório' : 'Opcional'
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        borderRadius: '16px',
        backgroundColor: Theme.Colors.Grayscale.Four,
        padding: '4px 8px',
        minWidth: '104px',
      }}
      key={Math.random(0, label)}
    >
      <div
        style={{
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: color,
          marginRight: 8,
        }}
      />
      <span style={{ color: Theme.Colors.Grayscale.SixtyFour, fontSize: '14px' }}>{label}</span>
    </div>
  )
}
